import { render, staticRenderFns } from "./PluginOnboarding.vue?vue&type=template&id=1d99c70e"
import script from "./PluginOnboarding.vue?vue&type=script&lang=ts"
export * from "./PluginOnboarding.vue?vue&type=script&lang=ts"
import style0 from "./PluginOnboarding.vue?vue&type=style&index=0&id=1d99c70e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports